import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdminNote } from '../AdminNote/AdminNote';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAlert } from 'common/alertContext';
import { useForm } from 'react-hook-form';
import api from 'api';

export const AdminNoteProgram = ({ open, programId, adminNote, onClose }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { setStateAlert } = useAlert();

  const mutateProgramAdminNote = useMutation(api.Programs.update, {
    onSuccess: () => {
      setStateAlert({
        message: t('admin_note_program.alert'),
        open: true,
      });

      queryClient.invalidateQueries(['list-programs']);
    },
  });

  const { control: internalControl, watch: internalWatch } = useForm({ mode: 'all', defaultValues: { adminNote } });

  return (
    <AdminNote
      open={open}
      title={t('admin_note_program.title')}
      editorName="adminNote"
      handleSubmit={() => {
        const adminNote = internalWatch('adminNote');
        mutateProgramAdminNote.mutate({ id: programId, body: { adminNote } });
        onClose();
      }}
      control={internalControl}
      onClose={onClose}
    />
  );
};
